import 'Content/font-awesome-pro-6.1.0/css/all.min.css';